export default __webpack_public_path__ + "static/media/markersemi.354da8d4.png";